module.exports = __webpack_public_path__ + "static/media/contour.ae56b11e.svg";